module.exports = __webpack_public_path__ + "static/media/th-room--vault2.c0ab5844.svg";